// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';

type Props = {
  i18nPath: string,
  note: number,
};

type State = {};

class UniquenessQuestion extends React.Component<Props, State> {

  getScoreCircle = () =>
    Array.from(Array(10).keys())
      .map((i: number) => (
        <div className="score-circle">
          <div className="circle">
            <div className={`circle-size-${Math.abs(4.5-i) + 0.5} circle-left ${(this.props.note > i) ? 'red' : 'white'}`} />
            <div className={`circle-size-${Math.abs(4.5-i) + 0.5} circle-right ${(this.props.note > i + 0.5) ? 'red' : 'white'}`} />
          </div>
          {i+1}
        </div>
      ));


  render() {
    return (
      <div className="survey-question-container">
        <div className="survey-question">
          <Translate value={`${this.props.i18nPath}.question`} />
        </div>
        <div className="score-circle-container">
          {this.getScoreCircle()}
        </div>
        <div className="score-explanation-container">
          <div className="score-explanation">
            <Translate value={`${this.props.i18nPath}.lowScore`} />
          </div>
          <div className="score-explanation">
            <Translate value={`${this.props.i18nPath}.highScore`} />
          </div>
        </div>
      </div>
    );
  }
}

export default UniquenessQuestion;